import { isNil } from "lodash";

export class Storage {
	static local(opts) {
		return new Storage(localStorage, opts);
	}

	static session(opts) {
		return new Storage(sessionStorage, opts);
	}

	constructor(backend, opts = {}) {
		this.backend = backend;
		this.cacheFor = opts.cacheFor;
	}

	get(key, fallback) {
		if (this.cacheFor) {
			const now = Date.now();
			const lastModified = this.backend.getItem(`$${key}`);
			if (now - lastModified > this.cacheFor) {
				return fallback;
			}
		}

		const value = this.backend.getItem(key);
		if (!isNil(value)) {
			return JSON.parse(value);
		}
		return fallback;
	}

	set(key, value) {
		this.backend.setItem(`$${key}`, Date.now());
		this.backend.setItem(key, JSON.stringify(value));
	}

	remove(key) {
		this.backend.removeItem(`$${key}`);
		this.backend.removeItem(key);
	}
}
